module.exports = __webpack_public_path__ + "media/images/business/cards/technology-hover-d602f4b6fe8cb39b115787421618fc24.png";